import React, { useState } from 'react';
import './Common.scss';
import NaviMenu from './NaviMenu';

const MenuButton: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const toggleMenu = (): void => {
    setIsMenuOpen(prevState => !prevState);
  };

  return (
    <div>
      <button
        className={`customer-support-button ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
      >
        Menu
      </button>
      {isMenuOpen ? (
        <NaviMenu isOpen={isMenuOpen} onClose={toggleMenu} />
      ) : null}
    </div>
  );
};

export default MenuButton;
